var map = {
	"./PremiumForm": [
		123,
		22
	],
	"./PremiumForm.vue": [
		123,
		22
	],
	"./PremiumList": [
		124,
		3
	],
	"./PremiumList.vue": [
		124,
		3
	],
	"./PremiumView": [
		125,
		23
	],
	"./PremiumView.vue": [
		125,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 452;
module.exports = webpackAsyncContext;